import { CloseDropEventType } from './../../app.event.type';
import { Router } from '@angular/router';
import { Component, OnInit, ViewEncapsulation, Input, OnDestroy } from '@angular/core';
import { TweenMax, Power2 } from 'gsap';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { EventTypes } from '../EventTypes';
import { User } from '../../autentication/models/user';
import { Auth } from '../../autentication/Auth';
import { Account } from '../../autentication/models/account';
import { AutenticationEventType } from '../../autentication/autentication.event.type';
import { AutenticationService } from '../../autentication/autentication.service';
import { SharedService } from '../shared.service';
import { ThemeService } from '../theme-service/theme.service';
import { AccountNumberPipe } from '../account-number.pipe';

@Component({
	selector: 'app-profile',
	templateUrl: './profile.component.html',
	styleUrls: ['./profile.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ProfileComponent implements OnInit, OnDestroy {
	primaryColor: any;

	@Input() scrollHeight = 280;

	open = false;
	filteredAccountList: Account[];
	findedAccount: Account[];
	selectedAccount: any;
	user: User;
	accountsList: Array<Account>;
	myAccountsList: Array<object> = [];
	outersAccountsList: Array<object> = [];
	showAccountsList = false;
	isAttendant: boolean = false;


	sending: boolean;

	openMenuProfile(open) {

		if (!this.sending) {

			this.open = open;

			if (this.open) {
				this.open = false;
			} else {
				this.open = true;
			}

			this.toggle();
		}

	}

	constructor(private router: Router, private authService: AutenticationService, private themeService: ThemeService) {

	}

	toggle() {
		const contentProfile = this.scrollHeight;
		let listProfile = 0;


		listProfile = $('[data-component="header"] [data-component="profile"] .profile-list').outerHeight() + 1;


		if (this.open) {
			TweenMax.to('main .closeDrop', 0, {display: 'block'});

			if (contentProfile > listProfile) {
				TweenMax.to('[data-component="profile"] .profile-dropdown', .7, {
					height: listProfile,
					ease: Power2.easeOut
				});

				this.arrowUp();

			} else {
				TweenMax.to('[data-component="profile"] .profile-dropdown', .7, {
					height: contentProfile,
					ease: Power2.easeOut
				});

				this.arrowUp();

			}
		} else {
			TweenMax.to('main .closeDrop', 0, { display: 'none' });


			TweenMax.to('[data-component="profile"] .profile-dropdown', .5, {
				height: 0,
				ease: Power2.easeOut
			});

			TweenMax.to('[data-component="profile"] .material-icons.arrow', .5, {
				rotation: 0
			});
		}
	}

	arrowUp() {
		TweenMax.to('[data-component="profile"] .material-icons.arrow', .5, {
			rotation: 180
		});
	}

	checkAccessPix() {
		this.authService.getPixAccessAvailable().subscribe(data => {
			if (data.Sucesso) {
				const user: User = Auth.getInstance().getUser();
				user.accessPix = data.Retorno;
				Auth.getInstance().setUser(user);
				AppEventDispatcher.dispatch(EventTypes.MENU.CHANGE, { show: true });
			}
		});
	}

	selectAccount(account) {
		this.selectedAccount = account;
		this.findedAccount = Auth.getInstance().getAccountsList().filter(this.accountCompare, this.selectedAccount);

		this.filteredAccountList = Auth.getInstance().getAccountsList().filter(this.accountsFilter, this.selectedAccount);

		this.findedAccount[0].user.rule = this.findedAccount[0].rights;
		Auth.getInstance().setUser(this.findedAccount[0].user);

		this.user = Auth.getInstance().getUser();
		this.accountsList = this.filteredAccountList;

		this.myAccountsList = [];
		this.outersAccountsList = [];

		for (let i = 0; i < this.accountsList.length; i++) {
			const item = this.accountsList[i];
			if (item.rights === 'TRANSACIONAR') {
				this.myAccountsList.push(item);
			} else {
				this.outersAccountsList.push(item);
			}
		}

		this.sending = true;

		this.authService.setAccount().subscribe( data => {
			this.checkAccessPix();
			this.sending = false;
			AppEventDispatcher.dispatch(AutenticationEventType.ACCOUNT.CHANGE_ACCOUNT_MENU, null);
			AppEventDispatcher.dispatch(EventTypes.PROFILE.NOTIFICATIONS, {});
			AppEventDispatcher.dispatch(EventTypes.MENU.CHANGE, { show: true });

			if (this.router.url === '/') {
				AppEventDispatcher.dispatch(AutenticationEventType.ACCOUNT.CHANGE_ACCOUNT, null);
			} else {
				this.router.navigate(['']);
			}

		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});

		this.open = false;
		this.toggle();

	}

	accountsFilter(item, index, array) {
		return (item.user.accountNumber !== this);
	}

	accountCompare(item, index, array) {
		return (item.user.accountNumber === this);
	}

	ngOnInit() {
		this.user = Auth.getInstance().getUser();
		this.isAttendant = this.themeService.isAttendant();
		if (!this.isAttendant) {
			this.accountsList = Auth.getInstance().getAccountsList().filter(this.accountsFilter, this.user.accountNumber);
			for (let i = 0; i < this.accountsList.length; i++) {
				const item = this.accountsList[i];
				if (item.rights === 'TRANSACIONAR') {
					this.myAccountsList.push(item);
				} else {
					this.outersAccountsList.push(item);
				}
			}

			AppEventDispatcher.listen(CloseDropEventType.CLOSE_DROP, data => {
				this.open = data.open;
				this.toggle();
			});

			if (this.accountsList.length > 0) {
				this.showAccountsList = true;
			}
		} else {
			this.showAccountsList = false;
		}
		if (this.themeService.themeConfigs) {
			this.primaryColor = this.themeService.CorPrimaria ? this.themeService.CorPrimaria : '';
		}
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(CloseDropEventType.CLOSE_DROP);
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/profile/profile.component.ts